import { bl_fi_stmt_account_event_company_filter_RowClass } from '../../../dbschema/bl_fi_stmt_account_event_company_filter.model';
import { BaseContainerModel } from '../../base-container.model';

export class StatementOfAccountEventCompanyFilterModel extends BaseContainerModel {
  bl_fi_stmt_account_event_company_filter: bl_fi_stmt_account_event_company_filter_RowClass = new bl_fi_stmt_account_event_company_filter_RowClass();
}